module.exports = __webpack_public_path__ + "img/album_gold.81d8006a.jpg";